"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var userApi = _interopRequireWildcard(require("@/api/user"));
var companyappApi = _interopRequireWildcard(require("@/api/companyappApi"));
var _selectUser = _interopRequireDefault(require("./selectUser.vue"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var _selectCoupon = _interopRequireDefault(require("./selectCoupon.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    SelectUser: _selectUser.default,
    SelectCoupon: _selectCoupon.default
  },
  data: function data() {
    return {
      loading: false,
      visible: false,
      pram: {
        userIds: [],
        groupId: [],
        tagId: [],
        miniProgramId: [],
        userSource: 0,
        couponId: null,
        userType: null
      },
      USER_TYPE_OPTIONS: [{
        name: '指定用户',
        value: 1
      }, {
        name: '指定小程序',
        value: 2
      }, {
        name: '指定分组',
        value: 3
      }, {
        name: '指定标签',
        value: 4
      }],
      TYPE_TITLE: {
        1: '指定用户：',
        2: '指定小程序：',
        3: '指定分组：',
        4: '指定标签：'
      },
      couponLists: [],
      labelLists: [],
      groupList: [],
      companyList: [],
      selectVisible: false
    };
  },
  mounted: function mounted() {},
  methods: {
    throttle: _throttle.default,
    openInit: function openInit() {
      this.visible = true;
      this.pram = {
        userIds: [],
        groupId: [],
        tagId: [],
        miniProgramId: [],
        userSource: 0,
        couponId: null,
        userType: null
      };
      this.initSearch();
    },
    selectCoupon: function selectCoupon() {
      var _this$$refs$SelectCou;
      var _ref = this.pram || {},
        userType = _ref.userType,
        miniProgramId = _ref.miniProgramId,
        _ref$userIds = _ref.userIds,
        userIds = _ref$userIds === void 0 ? [] : _ref$userIds,
        _ref$groupId = _ref.groupId,
        groupId = _ref$groupId === void 0 ? [] : _ref$groupId,
        _ref$tagId = _ref.tagId,
        tagId = _ref$tagId === void 0 ? [] : _ref$tagId;
      var CHECK_MAP = [{
        noPass: !userType,
        warnTips: '请选择用户类型！'
      }, {
        noPass: userType == 1 && !(userIds !== null && userIds !== void 0 && userIds.length),
        warnTips: '请选择指定用户！'
      }, {
        noPass: userType == 2 && !(miniProgramId !== null && miniProgramId !== void 0 && miniProgramId.length),
        warnTips: '请先选择指定小程序！'
      }, {
        noPass: userType == 3 && !(groupId !== null && groupId !== void 0 && groupId.length),
        warnTips: '请先选择指定分组！'
      }, {
        noPass: userType == 4 && !(tagId !== null && tagId !== void 0 && tagId.length),
        warnTips: '请先选择指定标签！'
      }];
      var warnInfo = {};
      var isNoPass = CHECK_MAP === null || CHECK_MAP === void 0 ? void 0 : CHECK_MAP.some(function (item) {
        if (item.noPass) {
          warnInfo = item;
        }
        ;
        return item.noPass;
      });
      if (isNoPass && warnInfo.warnTips) {
        this.$message.warning(warnInfo.warnTips);
        return;
      }
      ;
      (_this$$refs$SelectCou = this.$refs['SelectCouponRef']) === null || _this$$refs$SelectCou === void 0 ? void 0 : _this$$refs$SelectCou.initOpen(this.pram);
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    initSearch: function initSearch() {
      var _this = this;
      this.groupList = [];
      this.labelLists = [];
      this.companyList = [];
      // 分组列表
      userApi.groupListApi({
        page: 1,
        limit: 9999
      }).then(function (res) {
        _this.groupList = (res === null || res === void 0 ? void 0 : res.list) || [];
      });
      //标签列表
      userApi.tagListApi({
        page: 1,
        limit: 9999
      }).then(function (res) {
        _this.labelLists = (res === null || res === void 0 ? void 0 : res.list) || [];
      });
      // 小程序列表
      companyappApi.customersListApi({
        types: 3
      }).then(function (res) {
        _this.companyList = res || [];
      });
    },
    handlerDelete: function handlerDelete(i, uid) {
      var _this$pram, _this$pram$userIds, _this$pram2, _this$pram2$userIds;
      var removeIdx = (_this$pram = this.pram) === null || _this$pram === void 0 ? void 0 : (_this$pram$userIds = _this$pram.userIds) === null || _this$pram$userIds === void 0 ? void 0 : _this$pram$userIds.findIndex(function (item) {
        return item.uid == uid;
      });
      removeIdx != -1 && ((_this$pram2 = this.pram) === null || _this$pram2 === void 0 ? void 0 : (_this$pram2$userIds = _this$pram2.userIds) === null || _this$pram2$userIds === void 0 ? void 0 : _this$pram2$userIds.splice(removeIdx, 1));
    }
  }
};